import axios from "axios"
import { isTokenExp } from "./isTokenExp"
import { v4 as uuidv4 } from 'uuid';
import { expandEnabledVendors } from "./expandEnabledVendors"

const GET_RATES = '/applet/v1/rate'
const GET_RATES_SUB_VENDOR = '/applet/v1/rate/p2p'

export const getRatesWithLimit = (values, selectedAcc, enabledVendorsFiltered, setEnabledVendors, setVendorsProcessed, setVendorsTimedOut, setOpenConfirmTimedOutModal, user, setShowTable, setRates, setLinearProgress, setRatesStopped, source, normalizeParams, selectedUn, history, lnft, laneDistance) => {
  let array = []
  let progress = 0
  let callsFinishedLocal = 0
  let vendorsProcessedLocal = []
  let vendorsTimedOutLocal = []
  let maxLimit = 6

  setShowTable(true)
  setRates([])
  setLinearProgress(0)
  setRatesStopped(false)

  let enabledVendorsFilteredLocal = expandEnabledVendors(values, enabledVendorsFiltered, user.enabledVendors)

  setEnabledVendors(enabledVendorsFilteredLocal)

    // Función para procesar las URLs
    const processUrls = async () => {
        let remainingVendors = [...enabledVendorsFilteredLocal] // Copia del array original
        const activePromises = new Set() // Set para controlar las promesas activas

        // Función para procesar una URL
        const fetchUrl = async (vendor) => {
        try {
          const response = await axios.get(!vendor?.carrierCode ? GET_RATES : GET_RATES_SUB_VENDOR, {
            params: !vendor?.carrierCode ? normalizeParams(vendor.id, lnft, laneDistance) : {carrierCode: vendor?.carrierCode, ...normalizeParams(vendor.id, lnft, laneDistance)} ,
            timeout: vendor?.rateTimeout ? parseInt(`${vendor?.rateTimeout}000`) : 30000,
            cancelToken: source.token
          }).then(response => {
            response.data.data.results?.filter(result => !result.error).forEach((newRate) => {
              if(newRate.SCAC && user.SCACFilteringEnabled){
                let duplicated = array.find(oldRate => oldRate.SCAC === newRate.SCAC && oldRate.serviceLevel.toLowerCase() === newRate.serviceLevel.toLowerCase() && oldRate.id !== newRate.id) || {}
      
                const ratesWithCarrierCode = enabledVendorsFilteredLocal.filter(e => e.carrierCode)
                const newVendorsFiltered = [...enabledVendorsFiltered.filter(e => !e.carrierCode)]
      
                ratesWithCarrierCode.forEach(rate => {
                  if(!newVendorsFiltered.find(a => a.id === rate.id)){
                    newVendorsFiltered.push(user.enabledVendors?.find(enabledVendor => enabledVendor.id === rate.id))
                  }
                })
      
                let vendorNew = newVendorsFiltered?.find(vendor => vendor.id === newRate.vendorId)
                let vendorDuplicated = duplicated.vendorId ? newVendorsFiltered?.find(vendor => vendor.id === duplicated.vendorId) : {id: '', is3PL: false, isDirectAccount: false}
      
                let eliminateDuplicated = array.filter(rate => JSON.stringify(rate) !== JSON.stringify(duplicated))
                
                if(vendorNew?.id && vendorDuplicated?.id){
                  if(vendorNew.is3PL && vendorDuplicated.is3PL){
                    if(newRate.total >= duplicated.total){
                      
                    }else{
                      array = [...eliminateDuplicated, newRate]
                    }
                  }else if(vendorNew.isDirectAccount && vendorDuplicated.isDirectAccount){
                    let max = Math.max(newRate.total, duplicated.total)
      
                    if(max === newRate.total){
      
                    }else if(max === duplicated.total){
                      array = [...eliminateDuplicated, newRate]
                    }
                  }else if(vendorNew.is3PL && vendorDuplicated.isDirectAccount){
                    if(duplicated.total > (newRate.total + parseFloat(user.SCACFilteringVarianceUSD)) && duplicated.total > (newRate.total * (1 + (parseFloat(user.SCACFilteringVariancePercentage) / 100)))){
                      array = [...eliminateDuplicated, newRate]
                    }else{
                      
                    }
                  }else if(vendorNew.isDirectAccount && vendorDuplicated.is3PL){
                    if(newRate.total <= (duplicated.total + parseFloat(user.SCACFilteringVarianceUSD)) && newRate.total <= (duplicated.total * (1 + (parseFloat(user.SCACFilteringVariancePercentage) / 100)))){
                       array = [...eliminateDuplicated, newRate]
                    }else{
                      
                    }
                  }
                }else{
                  array.push(newRate)
                }
              }else{
                array.push(newRate)
              }
            })
      
            setRates([...array])
      
            if(history.includes('history')){
              let freightInfo = values.freightInfo.map(values => {
                return {...values, id: ''}
              })
        
              let newSearch = {...values, selectedAcc, selectedUn, id: uuidv4(), hashId: `${JSON.stringify(selectedAcc)}${JSON.stringify(values.destination)}${JSON.stringify(values.origin)}${JSON.stringify(freightInfo)}${values.moneyAccessorialsInformation}${values.insuranceAddOn}${values.insuranceFreight}${values.commodityInsurance}`}
              let existingSearches = JSON.parse(localStorage.getItem(history)) || []
              let isDuplicated = existingSearches.find(search => search.hashId === newSearch.hashId)
        
              if(isDuplicated){
        
              }else{
                existingSearches.unshift(newSearch);
                localStorage.setItem(history, JSON.stringify(existingSearches));
              }
            }
      
            progress = progress + (100 / enabledVendorsFilteredLocal.length)
            setLinearProgress(progress)
            vendorsProcessedLocal.push(vendor)
            setVendorsProcessed(vendorsProcessedLocal.length.toString())
          }).catch(error => {
            if(error.toString().includes('timeout')){
              vendorsTimedOutLocal = [...vendorsTimedOutLocal, vendor]
              setVendorsTimedOut(vendorsTimedOutLocal)
            }else if(error.message !== 'Operation canceled by the user.'){
              progress = progress + (100 / enabledVendorsFilteredLocal.length)
              setLinearProgress(progress)
              vendorsProcessedLocal.push(vendor)
              setVendorsProcessed(vendorsProcessedLocal.length.toString())
            }
      
            if(error?.response?.data?.error?.message.length){
              if(error?.response?.status === 401){
                setRatesStopped(true)
                isTokenExp()
              }
            }
          }).finally(() => {
            callsFinishedLocal = callsFinishedLocal + 1
            if(callsFinishedLocal === enabledVendorsFilteredLocal.length){
              if(vendorsTimedOutLocal?.length){
                setOpenConfirmTimedOutModal(true)
              }
              setRatesStopped(true)
            }
            activePromises.delete(fetchUrl) // Remover la promesa completada
          })
        
            
        } catch (error) {
            console.error(`Error en ${vendor}:`, error)
        } finally {
            // activePromises.delete(fetchUrl) // Remover la promesa completada
        }
    }

    const scheduleNext = async () => {
      // Si no hay más URLs y no hay promesas activas, salimos
      if (remainingVendors.length === 0 && activePromises.size === 0) {
        // console.log("Procesamiento completado.");
        return;
      }

      // Si hay URLs pendientes y espacio para otra promesa
      if (remainingVendors.length > 0 && activePromises.size < maxLimit) {
        const url = remainingVendors.shift();
        const promise = fetchUrl(url).finally(() => {
          activePromises.delete(promise);
          scheduleNext(); // Llamar recursivamente para iniciar otra tarea
        });
        activePromises.add(promise);
      }

      // Si las promesas activas alcanzan el límite, esperar a que una termine
      if (activePromises.size >= maxLimit) {
        await Promise.race(activePromises);
        scheduleNext(); // Llamar recursivamente después de que una termine
      }
    };

    // Iniciar las primeras tareas
    for (let i = 0; i < maxLimit && remainingVendors.length > 0; i++) {
      scheduleNext();
    }
  }
    processUrls()
}